import { atom } from "jotai";

export type Master = { key: string; value: string }[];
export type Masters = Record<string, Master>;

export const masterAtom = atom<Masters>({});
